import { render, staticRenderFns } from "./patient_profile.vue?vue&type=template&id=0bd3719d&"
import script from "./patient_profile.vue?vue&type=script&lang=js&"
export * from "./patient_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports